import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getXoDemoMode } from "../../lib/xoDemoContext";
import {
  normalizeTraversalDemoCallSearch,
  shouldNormalizeToTraversalDemoCall,
} from "../../lib/callDemoSync";
import { XOPublicShellWithSuspense } from "../XOPublicShell";
import { XODemoSurfaceShell } from "../XODemoSurfaceShell";
import { CallRouteErrorBoundary } from "../AppErrorBoundary";

/**
 * Primer traversal uses public shell + continuity rail on /call?demo=1.
 * Production / guest / non-demo call keeps the demo surface shell.
 */
export function CallRouteShell({
  children,
  loadingLabel = "Loading XO Call…",
}: {
  children: ReactNode;
  loadingLabel?: string;
}) {
  const { pathname, search } = useLocation();

  if (pathname === "/call" && shouldNormalizeToTraversalDemoCall(search)) {
    return <Navigate to={{ pathname: "/call", search: normalizeTraversalDemoCallSearch(search) }} replace />;
  }

  const traversalDemo = pathname === "/call" && getXoDemoMode(search);

  if (traversalDemo) {
    return (
      <XOPublicShellWithSuspense loadingLabel={loadingLabel} fullBleed hideYouAreHere>
        <CallRouteErrorBoundary>{children}</CallRouteErrorBoundary>
      </XOPublicShellWithSuspense>
    );
  }

  return (
    <XODemoSurfaceShell loadingLabel={loadingLabel}>
      <CallRouteErrorBoundary>{children}</CallRouteErrorBoundary>
    </XODemoSurfaceShell>
  );
}
